import { apiClient } from './apiClient';

export interface ReviewResponse {
  review: {
    id: string;
    rating: number;
    review?: string;
    bonusPoints?: number;
    bonusTargetType?: string;
    bonusLinkType?: string;
    bonusLinkValue?: string;
  };
  nextReviewLink: { type: string; url: string } | null;
}

export interface ScreenshotResponse {
  pointsApplicationId: string;
}

export const reviewService = {
  createReview: (rating: number, review?: string, doctorId?: string): Promise<ReviewResponse> => {
    const body: any = { rating, review };
    if (doctorId) body.doctorId = doctorId;
    return apiClient.post('/webapp/reviews', body);
  },

  uploadScreenshot: (reviewId: string, file: File): Promise<ScreenshotResponse> => {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('reviewId', reviewId);
    return apiClient.post('/webapp/reviews/screenshot', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
